
import { Component, Vue } from 'vue-property-decorator'
import themeColor from './theme-color'
import { useSettingStore } from '@/store/setting'

@Component({
  name: 'SettingDrawer',
})
export default class extends Vue {
  private settingStore = useSettingStore()
  private visible = false
  private colorList = [
    {
      key: '薄暮',
      color: '#F5222D',
    },
    {
      key: '火山',
      color: '#FA541C',
    },
    {
      key: '日暮',
      color: '#FAAD14',
    },
    {
      key: '明青',
      color: '#13C2C2',
    },
    {
      key: '极光绿',
      color: '#52C41A',
    },
    {
      key: '拂晓蓝（默认）',
      color: '#1890FF',
    },
    {
      key: '极客蓝',
      color: '#2F54EB',
    },
    {
      key: '酱紫',
      color: '#722ED1',
    },
  ]
  protected created() {
    this.changeColor(this.settingStore.layoutColor)
  }
  private handleLayout(mode) {
    this.settingStore.setLayoutMode(mode)
  }
  private handleMenuTheme(theme) {
    this.settingStore.setTheme(theme)
  }
  private handleFixedMenu(fixed) {
    this.settingStore.setFixedMenu(fixed)
  }
  private handleFixedHeader(fixed) {
    this.settingStore.setFixedHeader(fixed)
  }
  private onClose() {
    this.visible = false
  }
  public toggle() {
    this.visible = !this.visible
  }
  private changeColor(color) {
    const hideMessage = this.$message.loading('正在切换主题！', 0)
    themeColor.changeColor(color).finally(() => {
      this.settingStore.setColor(color)
      setTimeout(() => {
        hideMessage()
      }, 10)
    })
  }
  private handleChangeMultipleTabs(fixed) {
    this.settingStore.setMultipleTabs(fixed)
  }
  private handleChangeBread(hasBread: boolean) {
    this.settingStore.setBread(hasBread)
  }
}
